export default "__VITE_ASSET__DWrl8sZp__"